module.exports = __webpack_public_path__ + "img/27.8447c7fa.jpg";